/**
 * @fileoverview Loading placeholder for the Dashboard page.
 * @description Mirrors the Dashboard's shape once past PageHeader (which needs no skeleton — its
 * copy is static, known before the query even runs): the KPI strip, the 6 summary cards, and the
 * "Needs Attention" list.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import Skeleton from '@/shared/components/atoms/Skeleton'
import KpiStripSkeleton from '@/shared/components/molecules/KpiStripSkeleton'

/**
 * @component
 */
function DashboardSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <KpiStripSkeleton />

      <section className="grid-cards grid gap-4">
        {Array.from({ length: 6 }, (_, index) => (
          <div
            key={index}
            className="flex flex-col gap-3.5 rounded-[10px] border border-divider bg-white p-4 sm:p-[18px]"
          >
            <div className="flex items-center gap-2.5">
              <Skeleton width={34} height={34} variant="circle" />
              <Skeleton width={110} height={15} />
            </div>
            <Skeleton width={70} height={28} />
            <Skeleton width="100%" height={8} />
          </div>
        ))}
      </section>

      <section className="rounded-[10px] border border-divider bg-white">
        <div className="p-4 sm:p-5">
          <Skeleton width={160} height={15} />
        </div>
        <div className="border-t border-divider">
          {Array.from({ length: 4 }, (_, index) => (
            <div
              key={index}
              className="flex items-center gap-4 border-b border-row-border px-4 py-3.5 last:border-b-0 sm:px-5"
            >
              <Skeleton width={4} height={30} />
              <Skeleton width="40%" height={13} />
              <Skeleton width={90} height={13} />
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default DashboardSkeleton
